/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */

'use client'

import React, { useState, useEffect, useRef } from 'react'
import Image from 'next/image'
import { useUserData } from '@utils/userUserData'
import assetLoader from '@utils/internalImageLoader'
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button'
import StyledComponentsRegistry from '@configs/registry'
import { validateVehicleNumber } from '@components/MainWidget/FastagWidget/helper'
import { ThemeProvider, AckoMainTheme } from '@acko-tech/building-blocks.ui.theme'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import Cookies from 'js-cookie'
import {
  INPUT_ICON,
  INPUT_ICON_LOGO,
  TAP_BTN_EVENT,
  AUTH_FASTAG_CLIENT,
} from '@components/MainWidget/FastagWidget/constants'
import CreateLead from '@services/createLead'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import {
  VAS_WIDGET_INPUT_PLACEHOLDER,
  WIDGET_INPUT,
  REG_NO_ERROR,
  FASTAG_DATA,
  FASTAG_WIDGET_INPUT,
  VIEW_FASTAG_BALANCE,
  ERROR_FETCHING_VEHICLE,
  SERVER_ERROR_MESSAGE,
  FETCHING_VEHICLE_DATA,
  ERROR_BIKE_ENTERED,
  ERROR_COMMERTIAL_VEHICLE_ENTERED,
} from '@components/MainWidget/ChallanWidgetLanding/constants'
import ReturningUserInfoBlock from '@components/MainWidget/ChallanWidgetLanding/returningUserInfoBlock'
import VasAppRedirectWrapper from '@components/MainWidget/ChallanWidgetModals/VasAppRedirectWrapper'
import { newFastagLoadingScreen } from '@components/MainWidget/ChallanWidgetModals/constants'
import LoadingScreen from '@components/MainWidget/ChallanWidgetModals/LoadingScreen'
import { getVasFinalScreenData } from '@factories/vasWidgetsFactory'
import {
  fetchDataFromLS,
  getFastagApiKeyLead,
  getFastagMMVStoreData,
  getFastagProductName,
  getFastagSourceName,
} from '@components/MainWidget/ChallanWidgetLanding/helper'
import { fastagBalanceWithErrorService } from '@services/fastagBalanceService'
import { vehicleInfoService } from '@services/vehicleInfoService'
import { processAssetData } from '@utils/assethelper'
import { widgetJourney } from '@configs/segmentEvents.config'
import { useEnvVariablesClientConfig } from '@context/EnvClientContext/EnvVariablesClientContext'
import { FastagUserData, FastagWidgetLandingProps, WrongModalState } from '@interfaces/fastag'
import { AuthLogin } from '@acko-tech/building-blocks.utils.auth-login-module'
import { useUserContext } from '@context/UserContext/UserContenxt'
import WrongProviderModal from '@components/MainWidget/FastagWidgetModals/wrongProviderModal'
import FASTagProvidersScreen from '@components/MainWidget/FastagWidgetModals/fastagProvidersScreen'
import {
  checkFastagLSData,
  defaultWrongModalState,
  initUserData,
} from '@components/MainWidget/FastagWidgetModals/constants'
import { isNotPrivateCar, isTwoWheeler } from '@enums/VehicleType'
import styles from './fastagWidgetLanding.module.scss'
import { FETCH_URL } from '../common/commonConstants'

const FastagWidgetLanding: React.FC<FastagWidgetLandingProps> = data => {
  const {
    widget,
    widgetHeading,
    regexPatternsData,
    widgetCtaText,
    inputPlaceholder,
    isMobileDevice,
    fastagFinalScreenData,
    fastagFallbackScreenData,
    segmentEventCommonProperties,
    isBottomFloater,
    onHide,
  } = data

  const fastagWrapperProps = getVasFinalScreenData(fastagFinalScreenData)
  const { isLoggedIn, setUserLoggedIn } = useUserContext()
  const userData = useUserData(isLoggedIn)
  const [phone, setPhone] = useState<string>(userData?.phone || '')
  const config = useEnvVariablesClientConfig()
  const currentEnv = config?.ACKO_ENV
  const [regNo, setRegNo] = useState('')
  const [error, setError] = useState('')
  const [widgetButtonText, setWidgetButtonText] = useState<string>(widgetCtaText || VIEW_FASTAG_BALANCE)
  const [returningUserResponse, setReturningUserResponse] = useState<any>(null)
  const [fastagUserData, setFastagUserData] = useState<FastagUserData>(initUserData)
  const [showLoadingModal, setShowLoadingModal] = useState<boolean>(false)
  const [showMobileAppRedirectWrapper, setShowMobileAppRedirectWrapper] = useState<boolean>(false)
  const [showMwebChallanModal, setShowMwebChallanModal] = useState<boolean>(false)
  const [showDoMoreThanChallanModal, setShowDoMoreThanChallanModal] = useState<boolean>(false)
  const [showProvidersModal, setShowProvidersModal] = useState(false)
  const inputPlaceHolder = inputPlaceholder || VAS_WIDGET_INPUT_PLACEHOLDER
  const [properties, setProperties] = useState<Record<string, string> | null>(null)
  const [providerErrorModal, setProviderErrorModal] = useState<WrongModalState>(defaultWrongModalState)
  const inputRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    const isUserLoggedIn = !!Cookies.get('user_id')
    setUserLoggedIn(isUserLoggedIn)
  }, [])

  useEffect(() => {
    if (userData?.phone) setPhone(userData?.phone)
  }, [userData])

  useEffect(() => {
    const fetchProperties = async () => {
      const resolvedProperties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
      setProperties(resolvedProperties)
    }
    fetchProperties().catch(error => {
      console.error('Error fetching properties:', error)
    })
  }, [segmentEventCommonProperties])

  useEffect(() => {
    const getLocalStorageData = async () => {
      if (!showLoadingModal) {
        const localStorageData = await fetchDataFromLS(FASTAG_DATA)
        if (checkFastagLSData(localStorageData)) {
          setReturningUserResponse(localStorageData)
        }
      }
    }
    getLocalStorageData()
  }, [showLoadingModal])

  const fetchFastagDataAndProceed = async (selectedProvider, registrationNumber, isReturningUser) => {
    if (!selectedProvider) return
    try {
      setShowLoadingModal(true)
      const [fastagData, vehicleInfo] = await Promise.all([
        fastagBalanceWithErrorService(registrationNumber, selectedProvider),
        vehicleInfoService(registrationNumber),
      ])
      if (!fastagData?.balance || !vehicleInfo?.variant_id) {
        setShowLoadingModal(false)
        setProviderErrorModal({
          show: true,
          isServerError: fastagData?.message === SERVER_ERROR_MESSAGE,
        })
        return
      }
      const updatedFastagData: FastagUserData = {
        mobile_number: phone,
        fastagData,
        vehicleInfo,
        reg_number: registrationNumber,
        selectedProvider,
      }
      try {
        const imageResponse = await processAssetData(vehicleInfo, FETCH_URL)
        updatedFastagData.vehicleImage = imageResponse?.variantDetails?.image
        updatedFastagData.logo_url = imageResponse?.variantDetails?.logo_url
      } catch (error) {
        console.error('Error fetching vehicle variant data', error, vehicleInfo)
      }
      setFastagUserData(updatedFastagData)
      if (!isReturningUser) {
        CreateLead({
          registrationNumber,
          phoneNo: phone,
          sourceName: getFastagSourceName(),
          apiKey: getFastagApiKeyLead(currentEnv),
        })
      }
      if (!providerErrorModal.show && checkFastagLSData(fastagUserData)) {
        setShowMobileAppRedirectWrapper(true)
        await getFastagMMVStoreData(updatedFastagData)
      }
      setShowLoadingModal(false)
      setRegNo('')
    } catch (error) {
      console.error('Error fetching fastag data:', error, registrationNumber)
      setShowLoadingModal(false)
      setFastagUserData(initUserData)
    }
  }

  const handleReturningSearch = () => {
    if (isLoggedIn && phone) {
      setRegNo('')
      setFastagUserData(returningUserResponse)
      onSubmitEvent(returningUserResponse)
      fetchFastagDataAndProceed(returningUserResponse?.selectedProvider, returningUserResponse?.reg_number, true)
    } else {
      setRegNo(returningUserResponse?.reg_number)
      initializeLoginSdk()
    }
  }

  const handleRegNoChange = e => {
    const newRegNumber = e?.target?.value.toUpperCase()
    setRegNo(newRegNumber)
  }

  const onSubmitEvent = data => {
    trackEvent(TAP_BTN_EVENT, {
      ...properties,
      ...{ journey: widgetJourney[widget] },
      product: getFastagProductName(),
      phone: data?.mobile_number || '',
      registration_number: data?.reg_number || '',
    })
  }

  const verifyOtpSuccess = async () => {
    setUserLoggedIn(true)
    setFastagUserData(prev => ({ ...prev, mobile_number: phone }))
    setShowProvidersModal(true)
  }

  const initializeLoginSdk = () => {
    // eslint-disable-next-line no-new
    new AuthLogin({
      clientId: AUTH_FASTAG_CLIENT,
      onSuccess: () => {
        verifyOtpSuccess()
      },
      enableScrollOnClose: true,
    })
  }

  const onFormSubmit = async e => {
    e.preventDefault()
    inputRef?.current?.blur()
    const vehicleError = validateVehicleNumber(regNo, regexPatternsData)
    if (!regNo || vehicleError) {
      setError(REG_NO_ERROR)
      return
    }
    setWidgetButtonText(FETCHING_VEHICLE_DATA)
    try {
      const vehicleData = await vehicleInfoService(regNo)
      if (!vehicleData || isNotPrivateCar(vehicleData?.vehicle_type_v2)) {
        setError(isTwoWheeler(vehicleData?.vehicle_type_v2) ? ERROR_BIKE_ENTERED : ERROR_COMMERTIAL_VEHICLE_ENTERED)
        return
      }
    } catch (error) {
      console.error('Error fetching the vehicle info', regNo)
      setError(ERROR_FETCHING_VEHICLE)
      return
    } finally {
      setWidgetButtonText(widgetCtaText || VIEW_FASTAG_BALANCE)
    }
    setError('')
    const updatedFastagData: FastagUserData = {
      ...fastagUserData,
      reg_number: regNo,
      ...(isLoggedIn && phone ? { mobile_number: phone } : {}),
    }
    setFastagUserData(updatedFastagData)
    onSubmitEvent(updatedFastagData)
    if (isLoggedIn && phone) setShowProvidersModal(true)
    else initializeLoginSdk()
  }

  const handleFastagProvidersSelect = selectedProvider => {
    setFastagUserData(prev => ({ ...prev, selectedProvider }))
    setShowProvidersModal(false)
    fetchFastagDataAndProceed(selectedProvider, regNo, false)
  }

  const handleFallbackModal = () => {
    setShowLoadingModal(false)
    setShowDoMoreThanChallanModal(false)
    setShowMobileAppRedirectWrapper(false)
    setError('')
  }

  const handleWrongProviderModal = () => {
    setProviderErrorModal(defaultWrongModalState)
    setShowProvidersModal(true)
  }

  return (
    <ThemeProvider theme={AckoMainTheme}>
      <>
        <div>
          {showProvidersModal && (
            <FASTagProvidersScreen
              isMobile={isMobileDevice}
              showProvidersScreen={showProvidersModal}
              setShowProvidersScreen={setShowProvidersModal}
              onSelect={handleFastagProvidersSelect}
            />
          )}

          {providerErrorModal.show && (
            <WrongProviderModal
              setProviderErrorModal={setProviderErrorModal}
              onClose={handleWrongProviderModal}
              setShowProvidersModal={setShowProvidersModal}
              providerErrorModal={providerErrorModal}
              isMobileDevice={isMobileDevice}
            />
          )}

          {showLoadingModal && (
            <LoadingScreen
              isMobile={isMobileDevice}
              screens={newFastagLoadingScreen}
              regNo={regNo || fastagUserData?.reg_number}
              isBottomFloater={isBottomFloater}
              showLoadingScreen={showLoadingModal}
            />
          )}

          {showMobileAppRedirectWrapper && (
            <VasAppRedirectWrapper
              mobileNo={fastagUserData?.mobile_number}
              isMobile={isMobileDevice}
              vasWrapperProps={fastagWrapperProps}
              vasFallbackScreenData={fastagFallbackScreenData}
              regNum={regNo || fastagUserData?.reg_number}
              vehicleInfoData={fastagUserData}
              segmentEventCommonProperties={properties}
              setShowMobileChallanModal={handleFallbackModal}
              isBottomFloater={isBottomFloater}
              onHide={onHide}
              showMwebChallanModal={showMwebChallanModal}
              setShowMwebChallanModal={setShowMwebChallanModal}
              showDoMoreThanChallanModal={showDoMoreThanChallanModal}
              setShowDoMoreThanChallanModal={setShowDoMoreThanChallanModal}
              widgetType={widget}
            />
          )}
        </div>
        <div id="fastag-widget-landing-widget" className={styles.widgetRootContainer}>
          {returningUserResponse?.vehicleInfo && (
            <ReturningUserInfoBlock
              userInfo={returningUserResponse}
              handleReturningSearch={handleReturningSearch}
              widgetType={widget}
            />
          )}
          <form className={`${styles.widgetForm}`} onSubmit={e => onFormSubmit(e)}>
            <label htmlFor={WIDGET_INPUT} className={styles.widgetHeading}>
              {widgetHeading}
            </label>
            <div className={error ? styles.inputErrorStyles : styles.inputBoxContainer}>
              <Image
                width={0}
                height={0}
                src={`${assetLoader()}${INPUT_ICON}`}
                className={styles.inputIcon}
                alt={INPUT_ICON_LOGO}
              />
              <input
                type="text"
                id={FASTAG_WIDGET_INPUT}
                ref={inputRef}
                placeholder={inputPlaceHolder}
                onChange={handleRegNoChange}
                autoComplete="off"
                value={regNo}
                maxLength={10}
              />
            </div>
            {error && <div className={styles.inputError}>{error}</div>}
            <StyledComponentsRegistry>
              <PrimaryButton className={styles.primaryButton}>{widgetButtonText}</PrimaryButton>
            </StyledComponentsRegistry>
          </form>
        </div>
      </>
    </ThemeProvider>
  )
}

export default FastagWidgetLanding
